<h1 class="titulo-message">
  <i class="{{icon}} icon {{colorIcon}}"></i><span>{{ titulo }}</span>
</h1>

<div class="msg-erro">
  <ng-content></ng-content>
</div>
